module.exports = __webpack_public_path__ + "media/images/icon__reddit@2x-59ac093bc85e12f419a0b1b3a6a3cee8.png";